module.exports = __webpack_public_path__ + "img/ar-logo-32x32.cc94caae.svg";